import type { GeraetAngelegt, IchAntwort } from '../shared/api.js';
import type { Geraeteklasse, Modus } from '../shared/pruefpunkte.js';
import { api, modus, token } from './api.js';
import { uebernimmVomServer } from './ergebnisse.js';
import { erkennePlattform } from './geraet.js';
import { lies, schreibe } from './speicher.js';

/** Angemeldet heißt: Für den aktuellen Modus (App oder Browser) liegt ein Token vor. */
export async function istAngemeldet(): Promise<boolean> {
  return (await token()) !== undefined;
}

export async function speichereAnmeldung(antwort: GeraetAngelegt, klasse: Geraeteklasse): Promise<void> {
  const m = antwort.geraet.modus;
  await schreibe(`token:${m}`, antwort.token);
  await schreibe(`geraetId:${m}`, antwort.geraet.id);
  await schreibe('name', antwort.geraet.name);
  await schreibe('klasse', klasse);
}

/**
 * Bringt die App ein Token aus dem anderen Modus mit, legt sie für den
 * aktuellen Modus einen eigenen Kontext an. Das passiert, wenn das iPhone beim
 * Installieren den Speicher aus Safari übernimmt oder Android App und Browser
 * denselben Speicher nutzen.
 */
export async function sicherstelleKontext(): Promise<'vorhanden' | 'angelegt' | 'fehlt'> {
  const m = modus();
  if (await token(m)) return 'vorhanden';
  const anderer: Modus = m === 'app' ? 'browser' : 'app';
  if (!(await token(anderer))) return 'fehlt';
  const klasse = (await lies('klasse')) ?? 'handy';
  const antwort = await api<GeraetAngelegt>('/api/geraete/kontext', {
    json: { modus: m, klasse, plattform: await erkennePlattform() },
    modus: anderer,
  });
  await speichereAnmeldung(antwort, klasse);
  if (m === 'app') await schreibe('speicherAusBrowser', true);
  return 'angelegt';
}

/** Holt Gerätestand und Ergebnisse vom Server und merkt sich QR-Daten und VAPID-Schlüssel für offline. */
export async function holeStand(): Promise<IchAntwort> {
  const ich = await api<IchAntwort>('/api/ich');
  await schreibe('qr', ich.qr);
  await schreibe('vapidPublicKey', ich.vapidPublicKey);
  await schreibe('name', ich.geraet.name);
  await uebernimmVomServer(ich.ergebnisse);
  return ich;
}

export async function meldePlattform(): Promise<void> {
  await api('/api/ich', { methode: 'PATCH', json: { plattform: await erkennePlattform() } });
}
